<div class="step-element">
  <h2>Bij welk onderdeel heeft u het probleem?</h2>
  <div class="step-content-label">Kies een onderdeel:</div>
  <div>
    <ul class="radioList">
      <li class="custom-control custom-radio" *ngFor="let item of elementList">
        <input type="radio" class="custom-control-input" [(ngModel)]="element" name="list_element" id="{{item.itemValue}}" value="{{item.itemValue}}" (change)="onItemChange(item)" mdbInput />
        <label class="custom-control-label" for="{{item.itemValue}}">{{item.itemName}}</label>
      </li>
    </ul>
  </div>
</div>
